const KB = "taxCalculator.pph23.knowledgeBase";

export const PPH23_KB_KEYS = {
  title: `${KB}.title`,
  subtitle: `${KB}.subtitle`,
  sections: [
    {
      type: "intro",
      parts: [
        { text: `${KB}.introPart1` },
        { text: `${KB}.introHighlight`, bold: true },
        { text: `${KB}.introPart2` },
      ],
    },
    {
      type: "text",
      title: `${KB}.whatIs.title`,
      description: `${KB}.whatIs.description`,
    },
    {
      type: "list",
      title: `${KB}.objects.rate15.title`,
      description: `${KB}.objects.rate15.description`,
      items: [
        `${KB}.objects.rate15.item1`,
        `${KB}.objects.rate15.item2`,
        `${KB}.objects.rate15.item3`,
      ],
    },
    {
      type: "list",
      title: `${KB}.objects.rate2.title`,
      description: `${KB}.objects.rate2.description`,
      items: [
        `${KB}.objects.rate2.item1`,
        `${KB}.objects.rate2.item2`,
        `${KB}.objects.rate2.item3`,
        `${KB}.objects.rate2.item4`,
        `${KB}.objects.rate2.item5`,
        `${KB}.objects.rate2.item6`,
        `${KB}.objects.rate2.item7`,
        `${KB}.objects.rate2.item8`,
        `${KB}.objects.rate2.item9`,
        `${KB}.objects.rate2.item10`,
        `${KB}.objects.rate2.item11`,
        `${KB}.objects.rate2.item12`,
      ],
    },
    {
      type: "list",
      title: `${KB}.withholders.title`,
      description: `${KB}.withholders.description`,
      items: [
        `${KB}.withholders.item1`,
        `${KB}.withholders.item2`,
        `${KB}.withholders.item3`,
        `${KB}.withholders.item4`,
      ],
    },
    {
      type: "table",
      title: `${KB}.rates.title`,
      description: `${KB}.rates.description`,
      headers: [`${KB}.rates.headerCondition`, `${KB}.rates.headerRate`],
      rows: [
        { cells: [{ key: `${KB}.rates.hasNPWP` }, { value: "15% atau 2%" }] },
        { cells: [{ key: `${KB}.rates.noNPWP` }, { value: "30% atau 4%" }] },
      ],
    },
    {
      type: "methods",
      title: `${KB}.howToCalculate.title`,
      description: `${KB}.howToCalculate.description`,
      methods: [
        {
          title: `${KB}.howToCalculate.withNPWP.title`,
          formulaKey: `${KB}.howToCalculate.withNPWP.formula`,
        },
        {
          title: `${KB}.howToCalculate.withoutNPWP.title`,
          formulaKey: `${KB}.howToCalculate.withoutNPWP.formula`,
          noteKey: `${KB}.howToCalculate.withoutNPWP.note`,
        },
      ],
    },
    {
      type: "list",
      title: `${KB}.exemptions.title`,
      description: `${KB}.exemptions.description`,
      items: [
        `${KB}.exemptions.item1`,
        `${KB}.exemptions.item2`,
        `${KB}.exemptions.item3`,
        `${KB}.exemptions.item4`,
        `${KB}.exemptions.item5`,
        `${KB}.exemptions.item6`,
      ],
    },
    {
      type: "label-value",
      title: `${KB}.deadlines.title`,
      description: `${KB}.deadlines.description`,
      items: [
        {
          labelKey: `${KB}.deadlines.remittance`,
          value: `${KB}.deadlines.remittanceValue`,
        },
        {
          labelKey: `${KB}.deadlines.reporting`,
          value: `${KB}.deadlines.reportingValue`,
        },
      ],
    },
    {
      type: "list",
      title: `${KB}.legalBasis.title`,
      items: [
        `${KB}.legalBasis.item1`,
        `${KB}.legalBasis.item2`,
        `${KB}.legalBasis.item3`,
        `${KB}.legalBasis.item4`,
        `${KB}.legalBasis.item5`,
        `${KB}.legalBasis.item6`,
      ],
    },
  ],
};
